import { useQuery } from '@tanstack/react-query'
import { getDashboardStats } from '../services/api.js'
import DailyActions from '../components/dashboard/DailyActions.jsx'
import MyCommissions from '../components/dashboard/MyCommissions.jsx'
import DashboardStatsGrid from '../components/dashboard/DashboardStatsGrid.jsx'
import DetailedStats from '../components/dashboard/DetailedStats.jsx'
import RecentActivity from '../components/dashboard/RecentActivity.jsx'
import QuickActions from '../components/dashboard/QuickActions.jsx'
import QuickStats from '../components/dashboard/QuickStats.jsx'

export default function Dashboard() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['dashboardStats'],
    queryFn: getDashboardStats,
    staleTime: 30000,
  })

  const dashStats = stats?.stats || {}

  return (
    <div className="view-container active" data-view="home">
      <DailyActions />

      <MyCommissions />

      <DashboardStatsGrid stats={dashStats} isLoading={isLoading} />
      
      <div className="main-content-grid">
        <DetailedStats stats={dashStats} isLoading={isLoading} />
        <RecentActivity activity={dashStats.recentActivity} isLoading={isLoading} />
        <QuickActions />
        <QuickStats stats={dashStats} isLoading={isLoading} />
      </div>
    </div>
  )
}
